import React, { ReactElement } from 'react';

import classes from './SystemOutage.module.css';

interface SystemOutageProps {
  message?: string;
  title?: string;
}

function SystemOutage({ message, title = 'System Outage' }: SystemOutageProps): ReactElement {
  return (
    <div className={`${classes.flexCenter} ${classes.viewHeight}`}>
      <img className={classes.imgStyles} src={process.env.PUBLIC_URL + '/assets/locks-sunset.jpg'} alt="System Outage" />
      <div className={classes.flexColumn}>
        <h2 className={classes.marginBottom}>{title}</h2>
        <h3 className={classes.marginBottom}>{message}</h3>
      </div>
    </div>
  );
}

export default SystemOutage;
